export default "__VITE_ASSET__CtR$0_0i__"